<select class="custom-select mr-2" style="width:auto;" [(ngModel)]="form" (change)="selectValue()" [attr.disabled]="disabled ? 'true' : null">
	<option value="any" *ngIf="allowAll === true">All studios</option>
	<option *ngFor="let studio of studios" [value]="studio.id">{{studio.name}}</option>
</select>
